import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../constants/maximum-page-size";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import ReportColumns from "../../models/ColumnDefinitions/ReportColumn";
import { Report } from "../../models/Report";
import ReportSearch from "../../models/search/ReportSearch";
import { removeColumns } from "../../models/utilities/columnHelper";
import { getAllReport } from "../../services/reportService";
import TableTab from "../tabs/table-tab";
import { appendFilter } from "../../utilities/filters";
import { ReportSubTypes } from "../../constants/report-types";

interface ReportStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setDescription: (discription: string) => void;
}

const ReportStep: FC<ReportStepProps> = ({ onNext, onBack, setDescription = () => { } }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const { setFieldValue } = useFormikContext<any>();
    const [report, setReport] = useState<Report>({
        id: 0,
        name: '',
        typeId: ""
    });

    useEffect(() => {
        if (taskSelected) {
            const buttonEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>;
            onLocalNext(buttonEvent)
        }
    }, [taskSelected])

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event });
            setDescription(report.name)
            setFieldValue("reportId", report.id);
            setFieldValue("report", report.nameOriginal);
        }
    }

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setReport({ ...selectedItem });
            setTaskSelected(true);
            onNext({}); //fake event
            setDescription(selectedItem.nameOriginal);
            setFieldValue("reportId", selectedItem.id);
            setFieldValue("report", selectedItem.nameOriginal);
        }
    }

    const filterToNameOnly = searchDescriptor => {
        return searchDescriptor.filter(item => item.accessor === 'name');
    };

    // remove vingcard from notifications selections.
    const filteredGetAllReport = (listParameters) => {
        return getAllReport({ ...listParameters, filters: appendFilter([ReportSubTypes.VINGCARD], 'Report subtype type id', 'reportSubType.id',[], "=out=") });
    };

    return (<div className="pt-3 pr-3 pl-3 h-full relative">
        <TableContextProvider
            usePagination
            useTable
            useFilter
            useSearch
            dataMethod={filteredGetAllReport}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            tableDescriptor={removeColumns(ReportColumns, ['type', 'description', 'createdBy', 'siteName'])}
            searchDescriptor={filterToNameOnly(ReportSearch)}
            disableSearch={false}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.selectTheReport)}
                selectRows={false}
                onRowClicked={(data) => (itemSelected(data))}
                tableId={'reportNotificationTable'}
                style={{ maxHeight: "calc(100% - 70px)" }}
                cyName="reportNotification"
            />
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>

            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${taskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>

    </div>)
}

export default ReportStep;
